<template lang="pug">
.historyContainer
  .hisotryItem
    h2: img(src="../assets/numbers3.svg" width="120")
    table.table.is-bordered.is-narrow.is-fullwidth
      thead
        tr
          th.date 購入日付
          th.price 購入金額
          th 購入番号
      tbody
        tr(v-for="(n, idx) in numbers3" :key="idx")
          td.date {{n.date}}
          td.price ¥ {{n.numbers.length * 200}}
          td.numCell: span.tag.is-primary(v-for="(n, idx) in n.numbers" :key="idx" style="margin:3px;") {{n}}

    .resultContainer
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th.date 日付
            th.winningNumber 当選番号
        tbody
          tr(v-for="num in numbers3WinningNumber" :key="num.number")
            td.winningdate {{num.date}}
            td.winningnumber {{num.number}}

  .hisotryItem
    h2: img(src="../assets/numbers4.svg" width="120")
    table.table.is-bordered.is-narrow.is-fullwidth
      thead
        tr
          th.date 購入日付
          th.price 購入金額
          th 購入番号
      tbody
        tr(v-for="(n, idx) in numbers4" :key="idx")
          td.date {{n.date}}
          td.price ¥ {{n.numbers.length * 200}}
          td.numCell: span.tag.is-primary(v-for="(n, idx) in n.numbers" :key="idx" style="margin:3px;") {{n}}

    .resultContainer
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th.date 日付
            th.winningNumber 当選番号
        tbody
          tr(v-for="num in numbers4WinningNumber" :key="num.number")
            td.winningdate {{num.date}}
            td.winningnumber {{num.number}}

  .hisotryItem
    h2: img(src="../assets/loto6.svg" width="120")
    table.table.is-bordered.is-narrow.is-fullwidth
      thead
        tr
          th.date 購入日付
          th.price 購入金額
          th 購入番号
      tbody
        tr(v-for="(n, idx) in loto6" :key="idx")
          td.date {{n.date}}
          td.price ¥ {{n.numbers.length * 200}}
          td.numCell: span.tag.is-primary(v-for="(n, idx) in n.numbers" :key="idx" style="margin:3px;") {{n}}

    .resultContainer
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th.date 日付
            th.winningNumber 当選番号
        tbody
          tr(v-for="(num, idx) in Loto6WinningNumber" :key="idx")
            td.winningdate {{num.date}}
            td.winningnumber
              span.tag.is-priamry(v-for="(n, idx) in num.number" :key="n" style="margin:3px;") {{n}}


  .hisotryItem
    h2: img(src="../assets/loto7.svg" width="120")
    table.table.is-bordered.is-narrow.is-fullwidth
      thead
        tr
          th.date 購入日付
          th 購入金額
          th 購入番号
      tbody
        tr(v-for="(n, idx) in loto7" :key="idx")
          td.date {{n.date}}
          td.price ¥ {{n.numbers.length * 300}}
          td.numCell: span.tag.is-primary(v-for="(n, idx) in n.numbers" :key="idx" style="margin:3px;") {{n}}

    .resultContainer
      table.table.is-bordered.is-narrow.is-fullwidth
        thead
          tr
            th.date 日付
            th.winningNumber 当選番号
        tbody
          tr(v-for="(num, idx) in Loto7WinningNumber" :key="idx")
            td.winningdate {{num.date}}
            td.winningnumber
              span.tag.is-priamry(v-for="(n, idx) in num.number" :key="n" style="margin:3px;") {{n}}
</template>

<script>
//import {db} from '../plugins/firebase'

export default {
  name: 'ixahistory',
  data(){
    return {
      n3: []
    }
  },
  computed: {
    numbers3(){
      return this.$store.getters['ixa/getNumbers3']
    },
    numbers4(){
      return this.$store.getters['ixa/getNumbers4']
    },
    loto6(){
      return this.$store.getters['ixa/getLoto6']
    },
    loto7(){
      return this.$store.getters['ixa/getLoto7']
    },
    numbers3WinningNumber(){
      return this.$store.getters['ixa/getNumbers3WinningNumber']
    },
    numbers4WinningNumber(){
      return this.$store.getters['ixa/getNumbers4WinningNumber']
    },
    Loto6WinningNumber(){
      return this.$store.getters['ixa/getLoto6WinningNumber']
    },
    Loto7WinningNumber(){
      return this.$store.getters['ixa/getLoto7WinningNumber']
    },
  },
  mounted(){
    this.$EventBus.$emit('naviClose')
  },
  /*
  firestore(){
    return {
      n3: db.collection('numbers3') 
    }
  }
  */
}
</script>

<style scoped lang="stylus">
.historyContainer
  width: 90%
  margin: 82px auto 90px auto
  padding-bottom: 40px
  .hisotryItem
    margin-top: 40px
    .table
      .date
        width: 30%!important
      .price
        width: 17%!important
      td, th
        vertical-align: middle
        font-size: 0.8rem
      td.numCell
        padding: 5px
</style>
